import React, { useEffect, useState } from "react";
import InputField from "../../../component/input-field";
import { sanitizeInput } from "../../../utils";
import TodoItems from "./TodoItems";
import SideModal from "../../../component/SideModal";
import TodoConfig from "./TodoConfig";
import { useDispatch, useSelector } from "react-redux";
import { createWorkflow, getWorkflowById } from "../../../redux/actions/configurationAction";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";
import * as Yup from "yup";
import { FieldArray, Form, FormikProvider, useFormik } from "formik";
import { getAssignmentActivityList } from "../../../redux/actions/assignmentAction";
import { useLocation, useNavigate } from "react-router-dom";
import { SET_WORKFLOW } from "../../../redux/constants";
import { getDeptWithUserAndCollaborators } from "../../../redux/actions/department";
import { closestCenter, DndContext, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";

const schema = Yup.object().shape({
  configuration_id: Yup.string(),
  configuration_name: Yup.string().required("This field is required."),
  configuration_desc: Yup.string(),
  workflow_todos: Yup.array().of(
    Yup.object().shape({
      configuration_setting_mapping_id: Yup.string().nullable(),
      activity_id: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string(),
      }),
      activity_customfields_id: Yup.string().nullable(),
      sequence: Yup.number().required("This field is required."),
      is_mandatory: Yup.boolean().required("This field is required."),
      duration: Yup.number().nullable(),
      loop_activity: Yup.string().nullable(),
      link_activity: Yup.string().nullable(),
      dependent_todo: Yup.string().nullable(),
      dependent_todo_custom_field_value: Yup.string().nullable(),
      dependent_todo_custom_field_id: Yup.string().nullable(),
      duration_type: Yup.string().nullable(),
    })
  ),
});

const Workflow = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useLocation().state;
  const [activeModal, setActiveModal] = useState(false);
  const [activeTodo, setActiveTodo] = useState(null);
  const [todoList, setTodoList] = useState([]);
  const [deptWithUser, setDeptWithUser] = useState({})
  const [ deletedConfiguration, setDeletedConfiguration] = useState([]);
  const { company } = useSelector((state) => state.auth);
  const { workflow } = useSelector((state) => state.configurationReducer);

  const sensors = useSensors(useSensor(PointerSensor));
  // Creating state for changing payloadState when element is drag
  const [draggingState, setDraggingState] = useState();

  const defautlValues = {
    configuration_id: state ? state.is_copy ? "" : state.configuration_id : "",
    configuration_name: "",
    configuration_desc: "",
    workflow_todos: [],
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: defautlValues,
    validationSchema: schema,
    onSubmit: (data) => {
      handleSubmit(data);
    },
  });

  useEffect(() => {
    if(state){
      const request = {
        id: state.configuration_id,
        onSuccess: () => {},
        onError: (error) => {
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content={error?.message}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        },
      };
      dispatch(getWorkflowById(request));
    }

    return () => {
      dispatch({
        type: SET_WORKFLOW,
        payload: {}
      });
    }
    
  }, [state]);

  useEffect(() => {
    const request = {
      company_id: company.id,
      onSuccess: (result) => {
        setTodoList(
          result.filter(item => item.deletedAt === null ).map((todoItem) => ({
          // result.map((todoItem) => ({
            label: todoItem.name,
            value: todoItem.id,
          }))
        );
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getAssignmentActivityList(request));
  }, []);

  useEffect(() => {
    const request = {
      company_id: company.id,
      onSuccess: (result) => {
       if(result?.data){
        setDeptWithUser(result.data)
       }
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getDeptWithUserAndCollaborators(request));
  }, []);

  

  useEffect(() => {
    if (Object.keys(workflow).length > 0 && todoList.length > 0) {
      let workflowData = [];

      formik.setFieldValue(
        "configuration_name",
        state?.is_copy ? `${workflow.configuration_name} copy` : workflow.configuration_name || ""
      );
      formik.setFieldValue(
        "configuration_desc",
        workflow.configuration_desc || ""
      );

      workflowData = workflow?.workflow_todos?.map((item) => {
        const todo = todoList.find((ele) => ele.value === item.activity_id);
        if (todo) item.activity_id = todo;
        delete item['configuration_id'];
        if(state?.is_copy) delete item['configuration_setting_mapping_id'];
        return item;
      });

      formik.setFieldValue("workflow_todos", workflowData);
    }
  }, [workflow, todoList]);

  useEffect(() => {
    if (activeTodo !== null) {
      setActiveModal(true);
    }
  }, [activeTodo]);

  useEffect(() => {
    if (!activeModal) {
      setActiveTodo(null);
    }
  }, [activeModal]);

  /*-------------------- Changing payload state when element is dragging --------------- */
  useEffect(() => {
    if (draggingState !== null) {
      let workflowTodoList = formik.values.workflow_todos;
      workflowTodoList = workflowTodoList.map((item, index) => {
        if (index === 0) {
          item.link_activity = null;
          item.duration = 0;
          item.duration_type = "hours";
          item.dependent_todo = null;
          item.dependent_todo_custom_field_value = null;
          item.dependent_todo_custom_field_id = null;
        } else if (index === workflowTodoList.length - 1) {
          item.loop_activity = null;
        } else {
          if (item?.link_activity) {
            const dataIndex = workflowTodoList.findIndex(
              (element) => element.activity_id.value === item.link_activity
            );
            if (dataIndex > index) {
              item.link_activity = null;
              item.duration = 0;
              item.duration_type = "hours";
            }
          }
          if (item?.dependent_todo) {
            const dataIndex = workflowTodoList.findIndex(
              (element) => element.activity_id.value === item.dependent_todo
            );
            if (dataIndex > index) {
              item.dependent_todo = null;
              item.dependent_todo_custom_field_value = null;
              item.dependent_todo_custom_field_id = null;
            }
          }
          if (item?.loop_activity) {
            const dataIndex = workflowTodoList.findIndex(
              (element) => element.activity_id.value === item.loop_activity
            );
            if (dataIndex !== -1 && dataIndex < index) {
              item.loop_activity = null;
            }
          }
        }
        return item;
      });

      formik.setFieldValue("workflow_todos", workflowTodoList);
    }
  }, [draggingState]);

  const handleSubmit = (data) => {

    if(data.workflow_todos.length === 0){
      swal({
        content: (
          <CustomeModal
            type="warning"
            title="Warning!"
            content={`Please add atleast one todo in workflow.`}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
      return;
    }

    const todositem = data.workflow_todos.map(item => ({
      ...item,
      activity_id: item.activity_id.value
    }))

    let payload = {
      configuration_name: data.configuration_name,
      configuration_desc: data.configuration_desc,
      workflow_todos: todositem,
      delete_configuration_mappings: deletedConfiguration
    };

    if(data.configuration_id) payload['configuration_id'] = data.configuration_id;

    const request = {
      payload,
      onSuccess: (res) => {
        navigate("/workflows");
      },
      onError: (error) => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={error?.message === "Duplicate entry" ? "A workflow with the provided name already exists." : error?.message}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(createWorkflow(request));

  }

  const handleDragEnd = (event) => {
    const { active, over } = event;

    const dragIndex = formik.values.workflow_todos.findIndex(item => item.activity_id.value === active.id);
    const hoverIndex = formik.values.workflow_todos.findIndex(item => item.activity_id.value === over.id);
    if(dragIndex === -1 || hoverIndex === -1){
      return;
    }
    let results = arrayMove(formik.values.workflow_todos, dragIndex, hoverIndex);
    results = results.map((item, index) => (
      {
        ...item,
        sequence: index + 1,
      }
    ))
    formik.setFieldValue("workflow_todos", results);
    setDraggingState(dragIndex);
  };

  return (
    <div className="sm:mx-6 lg:mx-8">
      <div className="w-full flex items-center space-x-4">
        <div className="w-full overflow-x-scroll no-scrollbar border-b border-b-[#D9D9D9]">
          <p
            className={`w-full block font-inter text-sm font-bold whitespace-nowrap leading-3 py-2`}
            id="users"
          >
            Workflow Details
          </p>
        </div>
        <button
            className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 cursor-pointer"
            onClick={() => {
              navigate("/workflows");
              formik.resetForm();
              dispatch({
                type: SET_WORKFLOW,
                payload: {}
              });
            }}
          >
            Cancel
          </button>
        <button
          className="btn !bg-[--bg-color-500] text-white"
          type="submit"
          onClick={(e) => {
            e.stopPropagation();
            formik.handleSubmit();
          }}
        >
          Save
        </button>
      </div>
      <div className="w-full py-5 space-y-5">
        {/* Workflow Details Sections */}
        <div className="flex flex-row items-center justify-start space-x-4">
          <InputField
            type="text"
            label="Workflow Name"
            wrapperClass="w-1/3"
            placeholder="Workflow Name"
            name="workflow_name"
            value={formik.values.configuration_name}
            onChange={(e) => {
              const value = sanitizeInput(e.target.value);
              formik.setFieldValue("configuration_name", value);
            }}
            onBlur={formik.handleBlur}
            error={
              Boolean(
                formik.touched.configuration_name &&
                  formik.errors.configuration_name
              )
                ? formik.errors.configuration_name
                : null
            }
            required
          />
          <InputField
            type="text"
            label="Workflow Description"
            wrapperClass="w-1/3"
            placeholder="Workflow Description"
            name="workflow_desc"
            value={formik.values.configuration_desc}
            onChange={(e) => {
              const value = sanitizeInput(e.target.value);
              formik.setFieldValue("configuration_desc", value);
            }}
            onBlur={formik.handleBlur}
            error={
              Boolean(
                formik.touched.configuration_desc &&
                  formik.errors.configuration_desc
              )
                ? formik.errors.configuration_desc
                : null
            }
          />
        </div>

        {/* Workflow Todos */}
        <div>
          <div className="w-fulll overflow-x-scroll no-scrollbar border-b border-b-[#D9D9D9]">
            <p
              className={`w-full block font-inter text-sm font-bold whitespace-nowrap leading-3 py-2`}
              id="users"
            >
              Workflow Details
            </p>
          </div>
          {/* <div className="py-4 space-y-3"> */}
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}
              >
                <SortableContext items={formik.values.workflow_todos.map(item => item.activity_id.value)} strategy={verticalListSortingStrategy}>
                  <FieldArray
                    name="workflow_todos"
                    render={(arrayHelpers) => (
                      <div className="py-4 space-y-3">
                        {formik.values.workflow_todos?.map((row, i) => (
                          <TodoItems
                            id={row.activity_id.value}
                            key={i}
                            row={row}
                            i={i}
                            todoList={todoList}
                            arrayHelpers={arrayHelpers}
                            activeTodo={activeTodo}
                            setActiveTodo={setActiveTodo}
                            deptWithUser={deptWithUser}
                            setDeletedConfiguration={setDeletedConfiguration}
                          />))}
                        <div className="w-full">
                          <button
                            className="w-full btn bg-white border-slate-200 hover:border-slate-300 text-[--bg-color-500] cursor-pointer font-semibold"
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              setActiveTodo(
                                formik.values.workflow_todos?.length || 0
                              );
                            }}
                          >
                            + Add To Do
                          </button>
                        </div>
                      </div>
                    )}
                  />
                </SortableContext>
              </DndContext>
            </Form>
          </FormikProvider>
        </div>
      </div>

      <SideModal
        isOpen={activeModal}
        setIsOpen={setActiveModal}
        title={""}
        subtitle={formik.values.workflow_todos[activeTodo]?.activity_id.label || "Add To Do"}
        widthClass={"w-[50%]"}
      >
        <TodoConfig
          data={formik.values.workflow_todos[activeTodo] || {}}
          activeTodo={activeTodo}
          setActiveModal={setActiveModal}
          todoList={todoList}
          workflowFormik={formik}
          is_copy={state?.is_copy}
          deptWithUser={deptWithUser}
        />
      </SideModal>
    </div>
  );
};

export default Workflow;
